export const MenuList = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "Services",
    url: "#services",
  },

  {
    title: "Testimonial",
    url: "#testimonial",
  },
  {
    title: "About",
    url: "#about",
  },
  {
    title: "Dashboard",
    url: "dashboard",
  },
];
